export const withNewPageIds = (columnData, pageIds) => ({ ...columnData, pageIds });
